<script lang="ts">
  export let teamOne: string;
  export let teamTwo: string;
</script>

<style>
  @keyframes blink {
    to {
      opacity: 0;
    }
  }

  p {
    margin: 10px 0;
    font-size: 2rem;
    font-weight: 800;
    animation: blink 0.4s 6 alternate;
  }

  #btn-cont {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  button {
    width: 120px;
    margin: 10px 0;
    padding: 10px 0;
    font-weight: 800;
    box-shadow: 1px 1px 3px black;
    cursor: pointer;
  }
  button:active {
    box-shadow: inset 0 0 3px black;
  }
</style>

<p>Who goes first?</p>
<div id="btn-cont">
  <button on:click>{teamOne.toUpperCase()}</button>
  <button on:click>{teamTwo.toUpperCase()}</button>
</div>
